import { useState } from 'react';
import { DataTable, Page, Card } from '@shopify/polaris';
import SettingsAddEditModal, { getSettingsEditLink } from '../../settingsAddEditModal';
import { openAddModal } from '../../../../shared/components/settingsFunctions.js';
import { truncate } from '../../../../shared/components/functions.jsx';
import Toasts from '../../../../shared/components/toasts/toasts.jsx';
import { useLookupStore } from '../../../../context/useStore.js';
import { useToggle } from '../../../../shared/useToogle.js';

export default function SettingsReminderTextsPage() {
  const [rappeltexts, setRappeltexts] = useLookupStore((state) => [state.rappeltexts, state.setRappeltexts]);
  const [modalOpen, setModalOpen] = useToggle(false);
  const [entryId, setEntryId] = useState('');
  const [isAdd, setIsAdd] = useState(true);
  const [entry, setEntry] = useState({
    TekstStart: { type: 'text', label: 'Beginning', max: '4000', multi: true, value: '' },
    TekstEnd: { type: 'text', label: 'Ending', max: '4000', multi: true, value: '' },
    TaalID: { type: 'select', label: 'Language', value: '' }
  });
  const [toast, setToast] = useState(false);
  const [errorToast, setErrorToast] = useState(false);

  const url = '/api/rappeltexts';
  const title = 'Payment reminder texts';

  const rows = rappeltexts.map((item) => [
    truncate(item.TekstStart, 50, false),
    truncate(item.TekstEnd, 50, false),
    getSettingsEditLink(setModalOpen, entry, setEntry, setIsAdd, setEntryId, item, item.counter)
  ]);

  return (
    <Page
      title={title}
      backAction={{ content: 'Settings', url: '/settings' }}
      fullWidth
      primaryAction={{ content: 'Add payment reminder text', onAction: async () => openAddModal(setModalOpen, entry, setEntry, setIsAdd, setEntryId) }}
    >
      <SettingsAddEditModal
        modalTitle={title}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        isAdd={isAdd}
        entry={entry}
        setEntry={setEntry}
        entryId={entryId}
        url={url}
        setToast={setToast}
        setErrorToast={setErrorToast}
        setItems={setRappeltexts}
      />
      <Toasts toast={toast} setToast={setToast} errorToast={errorToast} setErrorToast={setErrorToast} />
      <Card>
        <DataTable stickyHeader increasedTableDensity verticalAlign="middle" columnContentTypes={['text', 'text', 'numeric']} headings={[<b>Beginning</b>, <b>Ending</b>, <b>Edit</b>]} rows={rows} />
      </Card>
    </Page>
  );
}
